// src/components/WarbandPDFDocument.js
import React, { useEffect } from 'react';
import { Page, Text, View, Document, Font } from '@react-pdf/renderer';
import { styles } from './ForbiddenPsalmPDFStyles';

const cinzelRegularUrl = '/fonts/Cinzel-Regular.ttf';
const unifrakturMaguntiaUrl = '/fonts/UnifrakturMaguntia-Regular.ttf';

const formatStat = (value) => (value > 0 ? `+${value}` : value);

const ForbiddenPsalmCardPDF = ({ warband, warbandName }) => {

  useEffect(() => {
    let didRegister = false;
    if (!didRegister && typeof window !== 'undefined') {
      try {
        console.log("Attempting to register fonts...");
        Font.register({ family: 'Cinzel', src: cinzelRegularUrl });
        Font.register({ family: 'UnifrakturMaguntia', src: unifrakturMaguntiaUrl });
        console.log("Fonts registered successfully.");
        didRegister = true;
      } catch (error) {
        console.error("Error registering fonts inside useEffect:", error);
      }
    }
  }, []);

  return (
    <Document>
      <Page size="LETTER" orientation="landscape" style={styles.page}>
        <Text style={styles.warbandName}>{warbandName}</Text>
        <View style={styles.cardContainer}>
          {warband && warband.map((card, index) => (
            <View key={index} style={styles.card} wrap={false}>
              <Text style={styles.cardTitle}>{card.name} {card.title}</Text>
              {card.stats ? (
                // --- Character Card Layout ---
                <View>
                  {/* ... stats, feats, flaws, equipment ... */}
                   <View style={styles.statsContainer}>
                    <View style={styles.statsColumn}>
                      <Text style={styles.paragraph}><Text style={styles.label}>Agility:</Text> {formatStat(card.stats.Agility)}</Text>
                      <Text style={styles.paragraph}><Text style={styles.label}>Presence:</Text> {formatStat(card.stats.Presence)}</Text>
                      <Text style={styles.paragraph}><Text style={styles.label}>Strength:</Text> {formatStat(card.stats.Strength)}</Text>
                      <Text style={styles.paragraph}><Text style={styles.label}>Toughness:</Text> {formatStat(card.stats.Toughness)}</Text>
                    </View>
                    <View style={styles.statsColumn}>
                      <Text style={styles.paragraph}><Text style={styles.label}>Health Points:</Text> {card.stats.HP}</Text>
                      <Text style={styles.paragraph}><Text style={styles.label}>Movement:</Text> {card.stats.Movement}</Text>
                    </View>
                  </View>
                  <View style={styles.divider} />
                  <Text style={styles.paragraph}><Text style={styles.label}>Feats:</Text> {card.feats}</Text>
                  <Text style={styles.paragraph}><Text style={styles.label}>Flaws:</Text> {card.flaws}</Text>
                  <View style={styles.divider} />
                  <Text style={styles.paragraph}><Text style={styles.label}>Weapon:</Text> {card.weapon}</Text>
                  <Text style={styles.paragraph}><Text style={styles.label}>Armor:</Text> {card.armor}</Text>
                  <View style={styles.divider} />
                  <Text style={styles.paragraph}><Text style={styles.label}>Equipment:</Text></Text>
                  <View style={styles.list}>
                    {Array.isArray(card.equipment) && card.equipment.map((item, i) => (
                      <Text key={i} style={styles.listItem}>- {item}</Text>
                    ))}
                  </View>

                  {/* --- Add Notes Display in PDF --- */}
                  <View style={styles.divider} />
                  <View style={styles.notesSection}>
                    <Text style={styles.paragraph}><Text style={styles.label}>Notes:</Text></Text>
                    <Text style={styles.notesText}>{card.Notes}</Text>
                  </View>
                  {/* --- End Notes Display --- */}
                </View>
              ) : (
                // --- Scroll Card Layout ---
                <View>
                  <Text style={styles.paragraph}><Text style={styles.label}>Clean Scroll:</Text> {card.cleanScroll}</Text>
                  <Text style={styles.paragraph}><Text style={styles.label}>Unclean Scroll:</Text> {card.uncleanScroll}</Text>

                   {/* --- Add Notes Display in PDF (Scroll) --- */}
                   <View style={styles.divider} />
                   <View style={styles.notesSection}>
                     <Text style={styles.paragraph}><Text style={styles.label}>Notes:</Text></Text>
                     <Text style={styles.notesText}>{card.Notes}</Text>
                   </View>
                   {/* --- End Notes Display --- */}
                </View>
              )}
            </View>
          ))}
        </View>
      </Page>
    </Document>
  );
};

export default ForbiddenPsalmCardPDF;
